module.exports = __webpack_public_path__ + "assets/img/block-hover-d3bec804.png";